import React from 'react'
import TemplateInputName from '../inputs/TemplateInputName'
import TemplateInputPosition from '../inputs/TemplateInputPosition'
import Logo from '../layout/Logo'

const PaidTemplatePreview = (props) => {
  var order = props.order
  var design = order.design

  const styleObj = { backgroundColor: '' }
  const nameStyleObj = {
    marginLeft: '90px',
    paddingLeft: 0,
    color: ''
  }
  const positionStyleObj = {
    fontSize: '1.5em',
    marginLeft: '90px',
    paddingLeft: 0,
    color: ''
  }
  const logoStyleObj = {
    textAlign: 'right',
    paddingRight: 0,
    color: ''
  }
  var logo, logoWidth, dropdown

  if (design !== undefined) {
    logo = design.logo
    logoWidth = design.logoWidth
    dropdown = design.dropdown
    styleObj.backgroundColor = design.backgroundColor
    styleObj['--placeholder-color'] = design.textColor
    nameStyleObj.color = design.textColor
    positionStyleObj.color = design.textColor
    logoStyleObj.color = design.logoColor
  }
  return (
    <div className="image-preview" style={styleObj}>
      <div className="image-preview-editable">
        <div className="image-preview-name">
          <TemplateInputName nameStyleObj={nameStyleObj} />
          <TemplateInputPosition positionStyleObj={positionStyleObj} />
        </div>
        <div className="image-preview-logo">
          <Logo logo={logo} logoWidth={logoWidth} dropdown={dropdown} logoStyleObj={logoStyleObj}/>
        </div>
      </div>
    </div>
  )
}

export default PaidTemplatePreview
